import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[appImageError]",
})
export class ImageErrorDirective {
  constructor(private el: ElementRef) {}

  @HostListener("error", ["$event"])
  onError(event: Event) {
    const imgElement = this.el.nativeElement as HTMLImageElement;
    imgElement.src = "/icons/owl_find_job.svg";
  }
}
